import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import useGlobalSelectionsContext from '../../core/hooks/useGlobalSelectionsContext';
import InitiativeSelect from './InitiativeSelect';
import OrganizationSelect from './OrganizationSelect';
import './styles.scss';
import { twoFactorStatusTypes } from '../../core/constants/auth';

const GlobalSelectionsContainer = () => {
  const { initiativeId, hideOrganizationsSelect } = useGlobalSelectionsContext();
  const { twoFactorStatus } = useSelector(({ auth }) => auth.auth);

  const isSelectVisible = React.useMemo(
    () => twoFactorStatus !== twoFactorStatusTypes.needTotpSetup,
    [twoFactorStatus],
  );

  return (
    <div
      className={classNames([
        'd-flex align-items-center justify-content-center pb-md-0 global-selection pr-3',
        !hideOrganizationsSelect && 'w-xs-100 pb-2 pl-3',
      ])}
    >
      {!!initiativeId && <OrganizationSelect />}
      {isSelectVisible && <InitiativeSelect />}
    </div>
  );
};

export default GlobalSelectionsContainer;
